<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>缺陷监控</el-breadcrumb-item>
		</el-breadcrumb>
		<ToolBar v-on:select="handleSelectJT"></ToolBar>
		<div class="monitor_section" v-if="currentJT">
			<div class="header clearfix">
				<h3>最新缺陷记录</h3>
				<!-- {{ monitorTime }} -->
				<el-button style="float: right; padding: 3px 0" type="text" @click="handleFullScreen('defect_view')">最大化</el-button>
			</div>

			<div id="defect_view" :class="{ view: istrue }" v-loading="loading">
				<div v-show="defects.length == 0 && !loading">
					<span>还没有缺陷记录.</span>
				</div>
				<div class="defect_item" v-for="item in defects" :key="item._id.$oid">
					<DefectMonitorItem :defect="item" />
				</div>
				<div class="clearfix"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import maxwindous from './maxWindous.js'
	import ToolBar from './ToolBar'
	import { getDefectRequest, getDefectImageUrlByMd5 } from '@/network/requests/defect'
	import { defectStatisRequest } from '@/network/requests/defectStatis'
	import { defectTypeRequest } from '@/network/requests/defectType'
	import { modelRequest } from '@/network/requests/model'
	import { modelSideRequest } from '@/network/requests/modelSide'
	import DefectMonitorItem from './DefectMonitorItem'
	import { result } from 'lodash'
	export default {
		components: {
			ToolBar,
			DefectMonitorItem,
		},
		mixins: [maxwindous],
		data() {
			return {
				currentJT: null,
				defects: [],
				roll_id: '',
				loading: false,
				timer: null,
				detailsCanvas: null,
				currentItem: {},
			}
		},
		filters: {
			fil(val) {
				if (!val) return ''
				const value = val / 1000
				console.log('wnjia', value)
				return `${value}米`
			},
		},
		computed: {
			monitorTime() {
				var value = 10
				var lv = localStorage.getItem('MonitorTime')
				if (lv) {
					value = lv
				}

				return value * 1000
			},
			jt_id() {
				var jt_id = ''
				if (this.currentJT) {
					jt_id = this.currentJT._id.$oid
				}

				return jt_id
			},
		},
		watch: {
			async jt_id(val) {
				this.defects = []
				this.loading = true
				clearInterval(this.timer)
				try {
					//获取最新
					await this.getNewstDefectData(val)
				} catch (error) {
					this.defects = []
				} finally {
					this.loading = false
				}

				this.timer = setInterval(async () => {
					//获取最新
					await this.getNewstDefectData(val)
				}, this.monitorTime)
			},
		},
		methods: {
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jtInfo) {
				this.currentJT = jtInfo
			},
			/**
			 * 获取最新的缺陷记录。
			 */
			async getNewstDefectData(jt_id) {
				//获取最近的一个批次。
				var defectStatis = (
					await defectStatisRequest.queryPage({
						page: 1,
						pagesize: 1,
						filter: { jt_id: jt_id },
						sort: { _id: -1 },
						keys: { _id: 1 },
					})
				).data._embedded

				var defects = []
				if (defectStatis.length > 0) {
					this.roll_id = defectStatis[0]._id.$oid
				} else {
					this.defects = defects
					return
				}

				//获取批次对应的缺陷类型。
				var defectTypes = await defectTypeRequest.queryAll({ roll_id: this.roll_id })
				//获取批次对应的模板。
				var model = (await modelRequest.queryAll({ roll_id: this.roll_id }))[0]
				//获取模板对应的检测面。
				var modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid })

				//获取10个缺陷记录。
				defects = (
					await getDefectRequest(this.roll_id).queryPage({
						page: 1,
						pagesize: 10,
						filter: undefined,
						sort: { _id: -1 },
					})
				).data._embedded

				//合并缺陷图片记录。
				var tempArray = []
				for (var item of defects) {
					var type = defectTypes.find(t => t.type_index == item.type_index)
					var ms = modelSides.find(t => t.side_index == item.side_index)
					tempArray.push({ ...item, md5: item.md5, roll_id: this.roll_id, type_text: type.display, model_side_text: ms?.name })
				}

				console.log('获取最新缺陷记录', tempArray)
				this.defects = tempArray
			},
		},
		mounted() {},
		created() {},
		destroyed() {
			//清空定时器。
			clearInterval(this.timer)
		},
	}
</script>

<style scoped>
	.form-table {
		margin-bottom: 20px;
	}

	.defect_item {
		border: 1px #eee solid;
		float: left;
		width: 190px;
		margin-left: 5px;
		margin-right: 5px;
		margin-bottom: 10px;
		/* overflow-y: auto;
		height: 360px; */
	}
	.defect_item:hover {
		background-color: #eee;
	}

	.img_item {
		text-align: center;
	}
	.img_item img {
		height: 150px;
	}
	.view {
		background-color: #fff;
		padding: 20px;
	}
	.defection {
		overflow-y: auto;
		height: 360px;
	}
	.heightWindous {
		margin: 10px;
		height: auto;
		overflow: hidden;
	}

	.details_view {
		margin: 0 10px;
		padding: 0;
	}

	.details_view li {
		list-style: none;
		line-height: 30px;
	}
</style>
